import { Fragment, ReactElement } from "react";

/**
 * Render string as component to add one or many rendered components as part of a provided text block.
 *
 * The markers shoud be put like the followed example: "Hello %my friend%, how are you %today% ?" (% is the marker)
 */
export class StringAsComponent {
  private textParts: (string | ReactElement<any>)[] = [];

  constructor(private text: string) {}

  render(
    extractorMarker: string,
    renderComponent: (extractedString: string, componentIndex: number) => ReactElement<any>,
  ) {
    if (this.textParts.length > 0) {
      this.textParts = this.textParts.flatMap((text) => {
        if (typeof text !== "string") return text;
        return this._splitAndRender(text, extractorMarker, renderComponent);
      });
    } else {
      this.textParts = this._splitAndRender(this.text, extractorMarker, renderComponent);
    }

    return this;
  }

  value() {
    return (
      <>
        {this.textParts.map((textPart) => (
          <Fragment key={typeof textPart === "string" ? textPart : textPart.key}>{textPart}</Fragment>
        ))}
      </>
    );
  }

  private _splitAndRender(
    text: string,
    extractorMarker: string,
    renderComponent: (extractedString: string, componentIndex: number) => ReactElement<any>,
  ) {
    let componentIndex = -1;
    return text.split(extractorMarker).map((textPart, index) => {
      if (index % 2 > 0) {
        componentIndex++;
        return renderComponent(textPart, componentIndex);
      }
      return textPart;
    });
  }
}
